import React from 'react';
import { Col, Row } from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';

export default props => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <LabelInput
            name={'Name'}
            type={'text'}
            required={true}
            {...props.state.name}
            onChange={event => props.updateForm(event, 'name')}
          />
        </Col>
        <Col>
          <LabelInput
            name={'Contact Name'}
            type={'text'}
            {...props.state.contact_name}
            onChange={event => props.updateForm(event, 'contact_name')}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <LabelInput
            name={'Email (Separate emails with a comma)'}
            type={'text'}
            {...props.state.email}
            onChange={event => props.updateForm(event, 'email')}
          />
        </Col>
        <Col>
          <LabelInput
            name={'Phone'}
            type={'text'}
            {...props.state.phone}
            onChange={event => props.updateForm(event, 'phone')}
          />
        </Col>
        <Col>
          <LabelInput
            name={'Fax'}
            type={'text'}
            {...props.state.fax}
            onChange={event => props.updateForm(event, 'fax')}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <LabelInput
            name={'Address Line 1'}
            type={'text'}
            {...props.state.address_line_1}
            onChange={event => props.updateForm(event, 'address_line_1')}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <LabelInput
            name={'Address Line 2'}
            type={'text'}
            {...props.state.address_line_2}
            onChange={event => props.updateForm(event, 'address_line_2')}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <LabelInput
            name={'City'}
            type={'text'}
            {...props.state.city}
            onChange={event => props.updateForm(event, 'city')}
          />
        </Col>
        <Col>
          <LabelInput
            name={'State'}
            type={'text'}
            {...props.state.state}
            onChange={event => props.updateForm(event, 'state')}
          />
        </Col>
        <Col>
          <LabelInput
            name={'Zip Code'}
            type={'text'}
            {...props.state.zip_code}
            onChange={event => props.updateForm(event, 'zip_code')}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};
